<template>
    <b-modal size="md" button-size="sm" hide-footer v-model="showModal" @hidden="cancelar" :title="title">
        <b-form @submit.prevent="save">
            <b-card>
                <b-form-row>
                    <b-col class='form-group' cols="12">
                        <span>Item: {{ ItemBemPermanenteLocal.descricaoResumida }}</span>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <lg-form-input invalidFeedback="Informe um valor atual válido!" description=" "
                        v-model="ItemBemPermanenteLocal.valorAtual" label="Valor Atual" type="number" cols="6"
                        readonly />
                    <lg-form-input :disabled="porcentagemValor == 2" invalidFeedback="Informe uma porcentagem válida!"
                        description=" "
                        :error="porcentagemValor == 2 ? null : $v.form.porcentagemDepreciacaoValorizacaoItemBemPermanente"
                        v-model="form.porcentagemDepreciacaoValorizacaoItemBemPermanente" label="Porcentagem (%): *"
                        cols="5" type='number' />
                    <b-form-radio @change="radioButonChange" class="mt-3" v-model="porcentagemValor"
                        value="1"></b-form-radio>

                </b-form-row>
                <b-form-row>
                    <lg-form-const-select label="Tipo de Alteração: *" md='6'
                        v-model="form.codTipoAlteracaoValorItemBemPermanente" :options="optionsFilterTipos" />
                    <lg-form-input :disabled="porcentagemValor == 1" invalidFeedback="Informe um valor válido!"
                        description=" "
                        :error="porcentagemValor == 1 ? null : $v.form.valorDepreciacaoValorizacaoItemBemPermanente"
                        v-model="form.valorDepreciacaoValorizacaoItemBemPermanente" label="Valor (R$): *" cols="5"
                        type='number' />
                    <b-form-radio @change="radioButonChange" class="mt-3" v-model="porcentagemValor"
                        value="2"></b-form-radio>

                </b-form-row>
                <b-form-row>
                    <b-col cols='6'>
                        <LgFinderPagePessoa v-model="form.codPessoaRespAvalDepValItemBemPermanente"
                            :prefix="title + ' > '" id="finderPagePessoa"
                            :error="$v.form.codPessoaRespAvalDepValItemBemPermanente" label="Responsável: *">
                        </LgFinderPagePessoa>
                    </b-col>
                    <lg-form-input invalidFeedback="Informe uma data válida!" description=" "
                        :error="$v.form.dataDepreciacaoValorizacaoItemBemPermanente"
                        v-model="form.dataDepreciacaoValorizacaoItemBemPermanente" label="Data: *" type="date"
                        cols="6" />
                </b-form-row>
                <b-form-row>
                    <lg-form-textarea description=" " v-model="form.observacaoDepreciacaoValorizacaoItemBemPermanente"
                        label="Observação:" cols="12" />
                </b-form-row>
                <div class="d-flex justify-content-center mt-3">
                    <b-button id="salvarReavaliacao" type="submit" variant="success" style="height: 30px" pill
                        size="sm">
                        <div class="btn-size-alinhamento">
                            <b-icon icon="check-circle" />
                        </div>
                        <b-tooltip target="salvarReavaliacao" title="Salvar" triggers="hover"></b-tooltip>
                    </b-button>
                    <b-button id="cancelarReavaliacao" class="ml-2" @click="cancelar" style="height: 30px" pill
                        size="sm" variant="danger">
                        <div class="btn-size-alinhamento">
                            <b-icon icon="x-circle" />
                        </div>
                        <b-tooltip target="cancelarReavaliacao" title="Cancelar" triggers="hover"></b-tooltip>
                    </b-button>
                </div>
            </b-card>
        </b-form>
    </b-modal>
</template>

<script>
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue"
import ResourceService from "@/core/api/ResourceService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFormTextarea from "@/core/components/Form/LgFormTextarea.vue"
import { FormResourceMixin } from "@/core/mixins/resource"
import moment from "moment"
import { required } from "vuelidate/lib/validators"

export default {
    components: {
        LgFormInput,
        LgFormTextarea,
        LgFormConstSelect,
        LgFinderPagePessoa
    },
    mixins: [FormResourceMixin],
    validations: {
        form: {
            dataDepreciacaoValorizacaoItemBemPermanente: { required },
            codPessoaRespAvalDepValItemBemPermanente: { id: { required } },
            codTipoAlteracaoValorItemBemPermanente: { required },
            situacaoDepreciacaoValorizacaoItemBemPermanente: { required },
        },
    },
    computed: {
        updatedPrefix() {
            return [...this.prefix, this.id == null ? "Cadastro" : "Alteração"]
        },
        title() {
            return this.updatedPrefix.join(" > ")
        },
    },
    props: {
        isModal: Boolean,
        ItemBemPermanente: {
            type: Object,
            required: true,
        },
        id: Number,
        prefix: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    data() {
        return {
            ItemBemPermanenteLocal: this.ItemBemPermanente,
            porcentagemValor: "1",
            optionsFilterTipos: [],
            showModal: true,
            form: {
                dataDepreciacaoValorizacaoItemBemPermanente: "",
                codPessoaRespAvalDepValItemBemPermanente: "",
                codTipoAlteracaoValorItemBemPermanente: "",
                observacaoDepreciacaoValorizacaoItemBemPermanente: "",
                valorDepreciacaoValorizacaoItemBemPermanente: "",
                porcentagemDepreciacaoValorizacaoItemBemPermanente: "",
                situacaoDepreciacaoValorizacaoItemBemPermanente: 1,
                codItemBemPermanente: this.ItemBemPermanente.id,
                valorAtual: "",
            },
        }
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/reavaliacao`)
        new ResourceService(`/api/reavaliacao`).get(`tipos`).then((response) => {
            this.optionsFilterTipos = [
                ...response.data.map((item) => ({
                    text: item.descricaoTipoAlteracaoValorItemBemPermanente,
                    value: item.codTipoAlteracaoValorItemBemPermanente,
                })),
            ]
        })
    },
    async mounted() {
        if (this.id) {
            const { data } = await this.$service.findById(this.id)
            data.dataDepreciacaoValorizacaoItemBemPermanente = moment(data.dataDepreciacaoValorizacaoItemBemPermanente).format("YYYY-MM-DD")
            this.porcentagemValor = data.valorDepreciacaoValorizacaoItemBemPermanente?2:1

            this.form = data
        } else {
            this.form.dataDepreciacaoValorizacaoItemBemPermanente = new Date().toISOString().split('T')[0]
            this.form.situacaoDepreciacaoValorizacaoItemBemPermanente = 1
            this.porcentagemValor = 1;
        }

        if (!this.form.valorAtual) {
            this.form.valorAtual = this.ItemBemPermanente.valor
        }
    },
    watch: {
        'form.porcentagemDepreciacaoValorizacaoItemBemPermanente': function (newVal) {
            if (newVal && !isNaN(newVal) && this.form.valorAtual) {
                this.form.valorDepreciacaoValorizacaoItemBemPermanente = parseFloat((this.form.valorAtual * (newVal / 100)).toFixed(2))
            }
        },
        'form.valorDepreciacaoValorizacaoItemBemPermanente': function (newVal) {
            if (newVal && !isNaN(newVal) && this.form.valorAtual) {
                this.form.porcentagemDepreciacaoValorizacaoItemBemPermanente = parseFloat(((newVal / this.form.valorAtual) * 100).toFixed(2))
            }
        },
    },
    methods: {
        radioButonChange() {
            if (this.porcentagemValor == 1)
                this.form.valorDepreciacaoValorizacaoItemBemPermanente = null;
            else
                this.form.porcentagemDepreciacaoValorizacaoItemBemPermanente = null;
        },
        cancelar() {
            this.$emit("close")
        },
        async save() {
            if (!this.formIsValid ||
            (this.porcentagemValor == 1 && !this.form.porcentagemDepreciacaoValorizacaoItemBemPermanente) ||
            (this.porcentagemValor == 2 && !this.form.valorDepreciacaoValorizacaoItemBemPermanente)

            ) {
                this.$v.$touch()
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos do cadastro.",
                })
                return
            }

            try {
                const formToSend = {
                    ...this.form,
                    dataDepreciacaoValorizacaoItemBemPermanente: moment(this.form.dataDepreciacaoValorizacaoItemBemPermanente).format("YYYY-MM-DDTHH:mm:ss"),

                }
                await this.$saveResource(
                    formToSend,
                    "",
                    true,
                    {},
                    this.isModal
                )
                this.cancelar()
            } catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                })
            }
        },
        async fetchValorAtual() {
            try {
                const response = await this.$service.get(`/api/valor-atual/${this.id}`)
                this.form.valorAtual = response.data.valorAtual
            } catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                })
            }
        }
    },
}
</script>
